

@if (isLoading) {
  <div class="page-loader">
    <div class="loader-container">
      <img src="assets/icons/cue-logo.png" />
      @if(showText) {
        <div class="label">Loading...</div>
      }
    </div>
  </div>
}
